import CircleProgress from '@activities/membership/stamp/StampsActivity/components/StampHeader/CircleProgress';
import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { StampCardRow } from '@models/stamp';
import { useAtom, useSetAtom } from 'jotai';
import { useEffect, useRef, useState } from 'react';

import { StampCount } from './constants/stampLayouts';
import FullCard from './FullCard';
import StampLog from './StampLog';
import styles from './styles.module.scss';
import SummaryCard from './SummaryCard';
import { expandStoreStampIdAtom, logExpandAtom } from '../../atoms/stampAtoms';

interface Props {
    stampCard: StampCardRow;
}

function StampCard({
  stampCard,
}:Props) {
  const {
    shopName, shopId, stampCount, totalSlots, stampExpiredDays,
  } = stampCard;
  const [expandId, setExpandId] = useAtom(expandStoreStampIdAtom);
  const ref = useRef<HTMLDivElement>(null);
  const expand = shopId === expandId;
  const [logExpand, setLogExpand] = useState<boolean>(false);
  const handleExpand = () => {
    setLogExpand(false);
    if (expand) {
      setExpandId('');
    } else {
      setExpandId(shopId);
      const scrollTimeout = setTimeout(() => {
        ref.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'nearest',
        });
      }, 400);
      return () => clearTimeout(scrollTimeout);
    }
    return () => {};
  };
  useEffect(() => {
    setLogExpand(false);
  }, [expand]);

  return (
      <Column fullWidth spacing={16}
              ref={ref}>
          <Anchor/>
          {expand && (
              <Row spacing={16} align='flex-start' fullWidth className={styles.contents}>
                  <CircleProgress count={stampCount}
                                  maxCount={totalSlots}/>
                  <Column fullWidth spacing={8}>
                      <Text size='xl' className={styles.left}>
                          쿠폰 발급까지 <br/>
                          스탬프 {totalSlots - stampCount}개 남았어요
                      </Text>
                      <Text size='s' color={colors.gray6} className={styles.toggle}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setLogExpand((prev) => !prev);
                            }}>
                          적립내역{logExpand ? '접기' : '보기'}
                      </Text>
                  </Column>
              </Row>
          )}
          <div className={styles.container}
               aria-label='stamp-card'
               onClick={handleExpand}>
              {expand && (
                  <Tooltip right='unset'
                           visibleKey='stampUsage'
                           top={-34}
                           align='left'
                           backgroundColor={colors.gray3}
                           color={colors.gray9}
                           left={12}>
                      색이 채워진 적립 스탬프를 눌러<br/>
                      남은 사용 기간을 확인해보세요
                  </Tooltip>
              )}

              <SummaryCard count={stampCount}
                           shopName={shopName}
                           hide={expand} />
              <FullCard stampCard={stampCard}
                        expand={expand} />
              <div className={styles.shop}>
                  <Text fontWeight='bold'>
                      {shopName}
                  </Text>
              </div>
              <StampLog shopId={shopId}
                        expand={logExpand} />
          </div>
      </Column>
  );
}

const Anchor = styled.div`
    margin-top: -70px;
    padding-bottom: 70px;
`;

const Root = styled.div`
    width: 100%;
`;

export default StampCard;
